import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=7311d552"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&id=7311d552&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7311d552')) {
      api.createRecord('7311d552', component.options)
    } else {
      api.reload('7311d552', component.options)
    }
    module.hot.accept("./CancellationPolicy.vue?vue&type=template&id=7311d552", function () {
      api.rerender('7311d552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/CancellationPolicy.vue"
export default component.exports